const namedCodesToUnicode = {
  shy: "\u00AD",
};
export default namedCodesToUnicode;
